import {createSelector} from '@ngrx/store';

import {DEPARTMENT_ADS_FEATURE_KEY, selectMasterDataModuleState} from '../reducers';

export const selectDepartmentAdsState = createSelector(
  selectMasterDataModuleState,
  (moduleState) => moduleState[DEPARTMENT_ADS_FEATURE_KEY]
);

export const selectDepartmentAdsEntities = createSelector(
  selectDepartmentAdsState,
  (state) => state.entities
);
export const sByIri = createSelector(
  selectDepartmentAdsState,
  (state, {iri}) => state.entities[iri]
);

export const selectDepartmentAds = createSelector(
  selectDepartmentAdsEntities,
  (entities) => Object.values(entities)
);

export const selectErrors = createSelector(
  selectDepartmentAdsState,
  (state) => state.errors
);
export const sUploadStatus = createSelector(
  selectDepartmentAdsState,
  (state) => state.uploadStatus
);

export const isLoading = createSelector(
  selectDepartmentAdsState,
  (state) => state.loading
);

export const isLoaded = createSelector(
  selectDepartmentAdsState,
  (state) => state.loaded
);
